import { NavLink } from 'react-router-dom';
import styles from './NavigationListItem.module.css';

type Props = {
	label: string;
	path: string;
};

const NavigationListItem = ({ label, path }: Props) =>
{
	if (path)
	{
		return (
			<NavLink to={path} className={({ isActive }) => `${styles.navigationListItem} ${isActive ? styles.active : ''}`}>
				{label}
			</NavLink>
		);
	}

	return (
		<div className={styles.navigationListItem}>{label}</div>
	);
};

export default NavigationListItem;